"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyEncryptionAlgorithm;
(function (KeyEncryptionAlgorithm) {
    KeyEncryptionAlgorithm["Rsa1_5"] = "http://www.w3.org/2001/04/xmlenc#rsa-1_5";
    KeyEncryptionAlgorithm["Rsa_oaep_mgf1p"] = "http://www.w3.org/2001/04/xmlenc#rsa-oaep-mgf1p";
})(KeyEncryptionAlgorithm = exports.KeyEncryptionAlgorithm || (exports.KeyEncryptionAlgorithm = {}));
//# sourceMappingURL=key-encryption-algorithm.js.map